module.exports = __webpack_public_path__ + "img/protection.7bbe5ce.svg";